//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLIENTES:                                      //   
//                                                      //   
//  APARECE COMO PREÇO UNITÁRIO DE UM PRODUTO           //
//  NO CARRINHO (ABA LATERAL DIREITA)                   //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR PREÇO UNITÁRIO              //    
//    DE CADA PRODUTO NO CARRINHO                       //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/produto_carrinho.js                     //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../assets/css/local/preco.css';

function PrecoCarrinho(props) {

    // FORMATA O PRECO UNITÁRIO (FORMATO XX.Y PARA XX,YY) 
    var id = props.props.id
    var preco = props.props[id]['preco'].toString()

    if(props.props.carrinho){
        preco = (parseFloat(preco)*parseInt(props.props[id].carrinho)).toString()
    }

    var preco_lista = preco.split('.')
    
    if(preco_lista.length === 2){
        var cents = preco_lista[1]
        
        if(cents.length === 1){
            cents = cents + '0'
        }
        if(cents.length > 2){
            cents = cents.slice(0, 2)
        }

        preco_lista[1] = cents
    }
    else if (preco_lista.length === 1){
        cents = '00'
        preco_lista.push(cents)
    }


    var preco_final = preco_lista.join(',')


    return (  // RENDERIZA O PREÇO
        <div class=''>
            <h5 class="preco_carrinho">R$ {preco_final}</h5>
        </div>
    );
}

export default PrecoCarrinho;
  